import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button } from "@/components/ui/button";
import { Eraser, Check } from "lucide-react";

// Module-level constant (not recreated every render) — passed as-is into
// SignatureCanvas's `canvasProps` below.
const SIGNATURE_CANVAS_PROPS = { className: "w-full h-40 sm:h-48" };

export const SignaturePad = ({ onSave, savedUrl }) => {
  const sigRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const clear = () => {
    sigRef.current?.clear();
    setIsEmpty(true);
  };

  const save = () => {
    if (!sigRef.current || sigRef.current.isEmpty()) return;
    const canvas = sigRef.current.getTrimmedCanvas ? sigRef.current.getTrimmedCanvas() : sigRef.current.getCanvas();
    const dataUrl = canvas.toDataURL("image/png");
    onSave(dataUrl);
  };

  if (savedUrl) {
    return (
      <div className="space-y-2">
        <div className="bg-white border rounded-[var(--radius)] p-3 flex items-center justify-center">
          <img src={savedUrl} alt="Signature" className="h-24 object-contain" />
        </div>
        <p className="text-xs text-emerald-700 font-medium">Signature captured</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div
        className="bg-white border rounded-[var(--radius)] overflow-hidden touch-none select-none"
        data-testid="signature-pad-canvas"
      >
        <SignatureCanvas
          ref={sigRef}
          penColor="#111827"
          onBegin={() => setIsEmpty(false)}
          canvasProps={SIGNATURE_CANVAS_PROPS}
        />
      </div>
      <p className="text-xs text-muted-foreground">Use your finger, mouse, or stylus to sign above.</p>
      <div className="flex gap-2">
        <Button type="button" variant="ghost" onClick={clear} data-testid="signature-pad-clear-button">
          <Eraser className="h-4 w-4 mr-2" />
          Clear
        </Button>
        <Button type="button" onClick={save} data-testid="signature-pad-save-button">
          <Check className="h-4 w-4 mr-2" />
          Use this signature
        </Button>
      </div>
    </div>
  );
};
